import Api from '../../../helpers/Api';

// ACTION  TYPE
export const NEW_DATA_TOP10 = 'NEW_DATA_TOP10';
const setNewDataToTop10 = (dataTop10, lastIdCategory) => ({
    type: NEW_DATA_TOP10,
    dataTop10,
    lastIdCategory,
});

export const NEW_DATA_CATEGORIES = 'NEW_DATA_CATEGORIES';
const setNewDataToTop10Categories = (dataTop10Categories) => ({
    type: NEW_DATA_CATEGORIES,
    dataTop10Categories,
});

export const TOP10_FADE_OUT = 'TOP10_FADE_OUT';
const setFadeOutTop10 = (isFadeOut) => ({
    type: TOP10_FADE_OUT,
    isFadeOut,
});

export const SET_IS_LOADING_TOP10 = 'SET_IS_LOADING_TOP10';
export const setIsLoading = (isLoading) => ({
    type: SET_IS_LOADING_TOP10,
    isLoading,
});

export const SET_NOT_FOUND_TOP10 = 'SET_NOT_FOUND_TOP10';
const setNotFound = (notFound) => ({
    type: SET_NOT_FOUND_TOP10,
    notFound,
});


// ACTION
export const fetchTop10CategoriesIfNeeded = () => (dispatch, getState) => {
    const dataCategories = getState().top10.dataCategories;

    if (dataCategories.length === 0) {
        return Api.progressGet(dispatch, '/api/v1/getTop10Categories')
            .then((json) => {
                if (json.status === 'success') {
                    return dispatch(setNewDataToTop10Categories(json.data));
                }

                throw `error from server: ${json.message}`;
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.log('fetchTop10Categories-> got error: ', error);
            });
    }

    return Promise.resolve(1);
};

export const getTop10DataIfNeeded = (idCategory = 1) => (dispatch, getState) => dispatch(fetchTop10CategoriesIfNeeded())
    .then(() => {
        let idCategoryHandle = idCategory;

        // if idCategory is not an integer, convert it to one:
        if (!Number.isInteger(idCategoryHandle)) {
            const dataCategories = getState().top10.dataCategories;

            // eslint-disable-next-line no-unused-vars
            for (const category of dataCategories) {
                // check if slug is equal category name to get id
                if (category.categorySlug === idCategoryHandle) {
                    idCategoryHandle = category.categoryId;

                    break;
                }
            }
        }

        // check if the category id has changed (it would be better to save the slug in the store and only work with the slug everywhere)
        const lastIdCategory = getState().top10.lastIdCategory;

        if (lastIdCategory !== idCategoryHandle) {
            dispatch(setNotFound(false));

            dispatch(setIsLoading(true));

            return Api.progressGet(dispatch, `/api/v1/getTop10/${idCategoryHandle}`)
                .then((json) => {
                    if (json.status === 'success') {
                        return dispatch(setNewDataToTop10(json.data, idCategoryHandle));
                    }

                    dispatch(setNotFound(true));

                    throw `error from server: ${json.message}`;
                });
        }

        return Promise.resolve(1);
    })
    .catch((error) => {
        // eslint-disable-next-line no-console
        console.log('fetchDataToTop10 -> got error: ', error);
    })
    .finally(() => {
        dispatch(setIsLoading(false));
    });

export const fadeOutTop10Control = (isFadeOut) => (dispatch) => {
    dispatch(setFadeOutTop10(isFadeOut));
};
